<template>
    <div>
        <article :id="nft.id" class="panel large pair entry">
            <header>
                <h3 aria-level="2" role="heading">{{ nft.metadata.title }} <small>by</small> {{ nft.metadata.author }}
                </h3>
            </header>
            <div class="primary">
                <template v-if="nft.media.type === 'image'">
                    <a :href="nft.media.visualiser ?? nft.ipfs.media" rel="nofollow">
                        <picture>
                            <template v-if="nft.media.file.substr(-4) === '.gif'">
                                <source
                                    :srcset="`/assets/bibliomp/${nft.media.file.replace('720.gif', '360.jpg')} 360w, /assets/bibliomp/${nft.media.file.replace('.gif', '.jpg')} 720w, /assets/bibliomp/${nft.media.file.replace('720.gif', '720@2x.jpg')} 1440w`"
                                    media="(prefers-reduced-motion:reduce)"
                                    sizes="(min-width:1280px) 720px, calc(100vw - 6.5rem)"
                                    type="image/jpeg">
                            </template>

                            <source
                                :srcset="`/assets/bibliomp/${nft.media.file.replace('720', '360')} 360w, /assets/bibliomp/${nft.media.file} 720w, /assets/bibliomp/${nft.media.file.replace('720', '720@2x')} 1440w`"
                                :type="nft.media.mime"
                                sizes="(min-width:1280px) 720px, calc(100vw - 6.5rem)">

                            <img :alt="nft.metadata.alt ?? nft.metadata.title"
                                 :data-src="`/assets/bibliomp/${nft.media.file}`"
                                 :height="nft.media.height"
                                 :width="nft.media.width"
                                 loading="lazy"
                                 src=""
                                 title="View Original">
                        </picture>
                    </a>
                </template>
                <template v-else-if="nft.media.type === 'video'">
                    <video :data-poster="`/assets/bibliomp/${nft.media.poster}`" :width="nft.media.width" controls
                           preload="none">
                        <source :src="`/assets/bibliomp/${nft.media.file}`" :type="nft.media.mime">
                    </video>
                </template>
            </div>

            <div class="secondary">
                <h4 aria-level="3" class="uc" role="heading">NFT</h4>
                <dl>
                    <dt>Token ID</dt>
                    <dd>{{ nft.token.name ?? nft.metadata.title }}</dd>

                    <dt>Artist</dt>
                    <dd>{{ nft.metadata.author }}</dd>

                    <template v-if="nft.ipfs">
                        <dt>IPFS Files</dt>
                        <dd><a :href="nft.ipfs.media" target="_blank"><span :class="`icon-${nft.media.type}`"></span>Media</a>
                        </dd>
                        <dd><a :href="nft.ipfs.json" target="_blank"><span class="icon-code"></span>JSON Metadata</a>
                        </dd>
                        <!-- <dd><a :href="nft.ipfs.coa" target="_blank"><span class="icon-cert"></span>Certificate of Authenticity</a></dd> -->
                    </template>

                    <dt>Issuer Address</dt>
                    <dd>{{ nft.token.issuer }}</dd>

                    <dt>Total Tokens Issued</dt>
                    <dd><b>Unlimited</b></dd>

                    <dt>Price per Token</dt>
                    <dd>{{ nft.token.price.xBiblx.toLocaleString('en-US') }} $xBiblx</dd>
                </dl>

                <template v-if="userSignedIn">
                    <dl style="margin-top: 12px">
                        <dt>Status</dt>
                        <dd><b>SOLD OUT</b></dd>
                    </dl>
                </template>

                <div v-else>
                    <i class="connect-wallet-text">Connect your wallet to set trustlines & purchase this Bibl Burn Bond</i>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
import SpinnerComponent from "../components/SpinnerComponent";

export default {
    name: "BibliompBondNfts",

    props: {
        nft: Object,
        channel: String,
        signedIn: Boolean,
    },

    components: {
        SweetModal,
        SweetModalTab,
        SpinnerComponent
    },

    data() {
        return {
            loading: false,
            loadingTrustline: false,
            loadingPayment: false,
            userSignedIn: this.signedIn,
            soldTokens: 0,
            trustLineSet: false,
            sessionChannel: this.channel,
        }
    },

    watch: {
        signedIn: {
            handler(newValue) {
                this.checkTokenStatus()
                this.userSignedIn = newValue
            },
            immediate: true
        },

        channel: {
            handler(newValue) {
                this.sessionChannel = newValue
            },
            immediate: true
        }
    },

    created() {
        this.configureScripts()
    },

    methods: {
        checkTokenStatus() {
            axios.get(`/check-token-status/${this.nft.token.hex}`)
                .then(response => {
                    this.soldTokens = response.data.soldTokens
                    this.trustLineSet = response.data.trustLineSet
                })
        },

        setTrustline: function (nft) {
            this.loadingTrustline = true
            Toast.fire({
                icon: 'info',
                title: 'We have sent a sign request on your Xumm app for your confirmation.'
            })
            axios.post('/set-bibliomp-bond-trustline', nft)
                .then((response) => {
                    let transactionId = response.data
                    let intervalId = setInterval(() => {
                        this.checkTransactionStatus(transactionId, intervalId)
                    }, 4000);
                })
                .catch(error => {
                    this.loadingTrustline = true
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.message
                    })
                })
        },

        buyToken: function (nft) {
            Swal.fire({
                title: 'WARNING!',
                html: '<p>NFT purchases are processed manually and may take up to 24 hours for the NFT transfer to complete once payment is received.</p> <p>Remember to set your trustline.</p> <p>If you experience any delays please contact hadanft@protonmail.com.</p> <p>Do NOT attempt to sell any XLS-14, 15 or 16D NFTs via the DEX. YOU CAN NOT SELL NFTS VIA THE DEX.</p> <p>All NFT purchases are final and returns are not accepted.</p>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Proceed!',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.loadingPayment = true
                    Toast.fire({
                        icon: 'info',
                        title: 'We have sent a sign request on your Xumm app for your confirmation.'
                    })
                    axios.post('/purchase-bibliomp', nft)
                        .then((response) => {
                            let transactionId = response.data
                            let intervalId = setInterval(() => {
                                this.checkTransactionStatus(transactionId, intervalId)
                            }, 4000);
                        })
                        .catch(error => {
                            this.loadingPayment = false
                            Toast.fire({
                                icon: 'error',
                                title: error.response.data.message
                            })
                        })
                }
            })
        },

        checkTransactionStatus: function (pendingTransactionId, interval) {
            axios.get(`/check-transaction-status/${pendingTransactionId}`).then(response => {
                if (response.data.status === 'success') {
                    this.loadingTrustline = false
                    this.loadingPayment = false
                    Toast.fire({
                        icon: response.data.status,
                        title: response.data.message
                    })
                    this.checkTokenStatus()
                    clearInterval(interval)
                    axios.post(`delete-pending-transaction/${pendingTransactionId}`)
                } else if (!this.is_null(response.data.status)) {
                    this.loadingTrustline = false
                    this.loadingPayment = false
                    Toast.fire({
                        icon: response.data.status,
                        title: response.data.message.startsWith('tec') ? this.getXrplMessage(response.data.message) : response.data.message
                    })
                    clearInterval(interval)
                    axios.post(`delete-pending-transaction/${pendingTransactionId}`)
                }
            })
        },

        configureScripts: function () {
            document.addEventListener('DOMContentLoaded', function () {
                if ('loading' in HTMLImageElement.prototype) {
                    const images = document.querySelectorAll('img[loading="lazy"]');
                    images.forEach(img => {
                        img.src = img.dataset.src;
                    });
                } else {
                    const script = document.createElement('script');
                    script.src = '/assets/lazysizes.min.js';
                    document.body.appendChild(script);
                }

                const multilines = document.querySelectorAll('.multiline p');
                window.onresize = function () {
                    document.querySelectorAll('.more').forEach(e => e.remove());

                    Array.prototype.forEach.call(multilines, function (element) {
                        if (element.textContent !== '' && element.scrollHeight > element.clientHeight) {
                            const a = document.createElement('span');
                            a.classList.add('more');
                            a.textContent = 'More';
                            element.parentNode.insertBefore(a, element.nextSibling);
                        }
                    });
                }
                window.dispatchEvent(new Event('resize'));

                function hasClass(elem, className) {
                    return elem.classList.contains(className);
                }

                document.addEventListener('click', function (e) {
                    if (hasClass(e.target, 'more')) {
                        e.preventDefault();

                        const parent = e.target.previousSibling;
                        parent.style.display = parent.style.display === 'block' ? '-webkit-box' : 'block';
                        e.target.textContent = e.target.textContent === 'More' ? 'Less' : 'More';
                    }
                });

            });

            window.addEventListener('load', function () {
                const videos = [].slice.call(document.querySelectorAll('video'));
                videos.forEach(function (video) {
                    video.poster = video.dataset.poster;
                });
            });
        }
    }
}
</script>

<style>
.connect-wallet-text {
    display: block;
    margin-top: 15px;
}
</style>
